
import { supabase } from "@/integrations/supabase/client";

/**
 * Soft delete an email template by setting is_active to false
 */
export async function deleteTemplate(id: string): Promise<boolean> {
  try {
    console.log(`Soft deleting template with ID: ${id}`);
    
    // Instead of deleting, we set is_active to false
    const { error } = await (supabase as any)
      .from('email_templates')
      .update({ is_active: false })
      .eq('id', id);

    if (error) {
      throw new Error(`Error deleting template: ${error.message}`);
    }

    return true;
  } catch (error: any) {
    console.error("Error in deleteTemplate:", error);
    throw new Error(`Failed to delete email template: ${error.message}`);
  }
}
